import PropTypes from "prop-types";

import { Chip, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { formatDate } from "@/features/shared";

import { statusColors, statusLabels } from "../../status";

export const GeneralInformationSection = ({ deliveryOrder }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Informasi Umum</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Status
          </Typography>
          {deliveryOrder.status && (
            <Chip
              label={statusLabels[deliveryOrder.status]}
              color={statusColors[deliveryOrder.status]}
              size="small"
            />
          )}
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Dibuat oleh
          </Typography>
          <Typography variant="body1">
            {deliveryOrder.creator?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Tanggal Pengiriman
          </Typography>
          <Typography variant="body1">
            {formatDate(deliveryOrder.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Pelanggan
          </Typography>
          <Typography variant="body1">
            {deliveryOrder.buyer?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Pemasok
          </Typography>
          <Typography variant="body1">
            {deliveryOrder.seller?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Gudang Pemasok
          </Typography>
          <Typography variant="body1">
            {deliveryOrder.warehouse?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Catatan
          </Typography>
          <Typography variant="body1">{deliveryOrder.note ?? "-"}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  deliveryOrder: PropTypes.object.isRequired,
};
